<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 55" class="gauge">
  <path pathLength="100" d="M 5 50 A 40 40 0 0 1 95 50" />
  <path class="value" pathLength="100" d="M 5 50 A 40 40 0 0 1 95 50" stroke-dashoffset="25" />
  <use class="svg-use" xlink:href="#visibility-off" width="35" height="33" x="33" y="20" />
</svg>
